import type { AlphaProgressResponses } from "./alphaProgressResponses";

export type AlphaSetupPath =
  | "/alpha"
  | "/alpha/brokerage"
  | "/alpha/ibkr/confirmation"
  | "/alpha/questionnaire"
  | "/alpha/review";

export interface AlphaSetupDestination {
  path: AlphaSetupPath;
  label: string;
}

export interface AlphaSetupDestinationOptions {
  hasCompletedReview: boolean;
  // isbeta settles the brokerage handoff outside the flow, so its two steps stop
  // gating entry. Review still collects the account name and type inline when the
  // saved responses do not carry them.
  isBrokerageProvisioned?: boolean;
}

export function getAlphaSetupDestination(
  responses: AlphaProgressResponses,
  {
    hasCompletedReview,
    isBrokerageProvisioned = false,
  }: AlphaSetupDestinationOptions
): AlphaSetupDestination | null {
  if (!responses.investmentTrackPreference) {
    return { path: "/alpha", label: "Choose your objectives" };
  }
  if (!isBrokerageProvisioned) {
    if (!responses.ibkrAccountChoice) {
      return { path: "/alpha/brokerage", label: "Choose your brokerage setup" };
    }
    if (
      !responses.ibkrSetupCompletion
      || !responses.ibkrAccountName
      || !responses.ibkrAccountType
    ) {
      return { path: "/alpha/ibkr/confirmation", label: "Complete account details" };
    }
  }
  if (
    !responses.riskProfile
    || responses.riskProfile.investmentTrack !== responses.investmentTrackPreference
  ) {
    return { path: "/alpha/questionnaire", label: "Complete your risk profile" };
  }
  if (!hasCompletedReview) {
    return { path: "/alpha/review", label: "Review and confirm your plan" };
  }
  return null;
}
